import { handleSearchParams } from "src/utils"
import { APICall } from "."
import { SubmitRecurringRequestBody } from "src/types/Requests/MobRecurringRequests"

const ControllerName = "MobRecurringRequests"

export const GetRecurringRequests = (searchParams: any, tableFiller: any, hospitalId: number) => {
    let searchData = handleSearchParams(searchParams, tableFiller)
    return APICall("get", ControllerName + `/GetPatientsForRecurringRequest${searchData}${hospitalId ? `&hospitalId=${hospitalId}` : ""}`)
}

export const GetRecurringDecisionMedicines = (decisionId: number, pharmId: number) => {
    return APICall("get", ControllerName + `/GetRecurringDecisionMedicines/${decisionId}?pharmacyId=${pharmId}`)
}

export const SubmitRecurringRequest = (data: SubmitRecurringRequestBody) => {
    return APICall("post", ControllerName + "/SubmitRecurringRequest", data)
}